<template>
  <div>
    <Notification :notify="notify" />
    <v-card class="d-flex pa-2 pb-2" outlined tile>
      <div class="row">
        <div class="col-8"><b>Publisher:</b> {{ PublisherName }}</div>
        <div class="col-4">
          <div class="float-right">
            <v-icon class="mr-2" @click="onRefresh()">mdi-cached</v-icon>
          </div>
        </div>
      </div>
    </v-card>
    <br />

    <v-card class="d-flex pa-2 pb-2" outlined tile>
      <div class="row">
        <div class="col">
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <!-- <th style="width: 50px"></th> -->
                  <th class="text-left">File</th>
                  <th class="text-left">Total Record Count</th>
                  <th class="text-left">Selected Record Count</th>
                  <th class="text-left">Processed Record Count</th>
                  <th style="width: 75px"></th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Start Date</th>
                  <th class="text-left">End date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ selectedFileData.FileName }}</td>
                  <td>{{ selectedFileData.TotalRecordCount }}</td>
                  <td>{{ selectedFileData.SelectedRecordCount }}</td>
                  <td>{{ selectedFileData.ImportedRecordCount }}</td>
                  <td>
                    <!--
                    <v-progress-linear
                      color="light-blue"
                      height="10"
                      :value="progress"
                      striped
                    ></v-progress-linear>  -->
                  </td>
                  <td>{{ selectedFileData.ImportedStatusDesc }}</td>
                  <td>{{ selectedFileData.JobStartTime | formatDateTime }}</td>
                  <td>{{ selectedFileData.JobEndTime | formatDateTime }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>

    <v-card class="d-flex pa-2 pb-2 mt-3" outlined tile>
      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <!--<th class="text-left">Title</th>  IsThumbnailNotFound-->
                  <th class="text-left">ISBN</th>
                  <th class="text-left">Publication Found</th>
                  <th class="text-left">Publication Uploaded</th>
                  <th class="text-left">Publication Encripted</th>
                  <th class="text-left">Thumbnail Uploaded</th>
                  <th class="text-left">Metadata Uploaded</th>
                  <th class="text-left">Is Imported</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listMataData" :key="item.id">
                  <!--<td>{{ item.Title }}</td>-->
                  <td>{{ item.ISBN }}</td>
                  <td>
                       <v-icon v-show="item.IsContentNotFound == false">mdi-check</v-icon
                    ><v-icon v-show="item.IsContentNotFound"
                      >mdi-close</v-icon
                    >
                  </td>
                  <td>
                    <v-icon v-show="item.isPublicationUploaded">mdi-check</v-icon>
                    <v-icon v-show="!!item.isPublicationUploaded && !item.isPublicationUploaded">mdi-close</v-icon>
                    <!--<v-progress-circular v-show="IsNullCheck(item.isPublicationUploaded)" indeterminate></v-progress-circular>-->
                  </td>
                  <td>
                    <v-icon v-show="item.isContentEncripted">mdi-check</v-icon
                    ><v-icon v-show="!!item.isContentEncripted && !item.isContentEncripted">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon v-show="item.isThumbnailUploaded">mdi-check</v-icon
                    ><v-icon v-show="!!item.isThumbnailUploaded && !item.isThumbnailUploaded">mdi-close</v-icon >
                  </td>
                  <td>
                    <v-icon v-show="item.isMetadataUploaded">mdi-check</v-icon
                    ><v-icon v-show="!!item.isMetadataUploaded && !item.isMetadataUploaded">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon v-show="item.isImported">mdi-check</v-icon
                    ><v-icon v-show="!!item.isImported && !item.isImported">mdi-close</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <Pagination :paging="paging" v-on:next="onNextPage" class="mt-5" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "IngestStatus",
  props: {
    FileId: { type: Number, required: true },
    FileName: { type: String, required: true },
    PublisherName: { type: String, required: true },
    SenderId: { type: Number, required: true },
    step: { type: Number, required: true },
  },
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  computed: {
    progress: function () {
      return (
        (this.selectedFileData.SelectedRecordCount /
          this.selectedFileData.ImportedRecordCount) *
        100
      );
    },
  },
  watch: {
    FileName: function (val) {
      this.FileName = val;
    },
    FileId: function (val) {
      console.log("val " + val);
      // if (val != "" && val != 0) {
      //this.getFileDetails(val);
      // this.getMetadata(val);
      // }
    },
    step: function (val) {
      if (val != "" && val != 0 && val == 5) {
        setTimeout(() => {
          this.getFileDetails(this.FileId);
          this.getMetadata(this.FileId);
        }, 2000);
      }
    },
  },
  created() {},
  methods: {
    IsNullCheck(val)
    {
       return val == null? true : false;
    },
    onRefresh() {
      this.getFileDetails(this.FileId);
      this.getMetadata(this.FileId);
    },
    getFileDetails(FileId) {
      new Promise((resolve, reject) => {
        api
          .getByID("import/onix/file", this.FileId)
          .then((response) => {
            console.log("selectedFileData " + JSON.stringify(response.data));
            this.selectedFileData = response.data;

            if (
              this.selectedFileData.ImportedStatus == 4 ||
              this.selectedFileData.ImportedStatus == 5
            ) {
              setTimeout(() => {
                this.getFileDetails(this.FileId);
              }, 10000);
            } else if (this.selectedFileData.ImportedStatus == 6) {
              this.getMetadata(this.FileId);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMetadata(FileId) {
      this.listMataData = [];
      new Promise((resolve, reject) => {
        api
          //.getAll("import/onix/metadata/" + fileName)
          .getByPagin(
            "import/onix/metadata/" + this.FileId + "/ingest",
            this.paging
          )
          .then((response) => {
            //this.listMataData = response.data;
            this.listMataData = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getMetadata(this.FileId);
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      listMataData: [],
      importData: {},
      loading: false,
      selectedFileData: {},
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/IngestStatus.vue